/**
 * Vehicle Insurance Claiming Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { GdvInsuranceClaimingBranchConfigurationDto } from '../model/gdvInsuranceClaimingBranchConfigurationDto';
import { GdvInsuranceClaimingConfigurationDto } from '../model/gdvInsuranceClaimingConfigurationDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class InsuranceClaimingConfigurationViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param branchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBranchConfiguration(branchId: string, observe?: 'body', reportProgress?: boolean): Observable<GdvInsuranceClaimingBranchConfigurationDto>;
    public getBranchConfiguration(branchId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GdvInsuranceClaimingBranchConfigurationDto>>;
    public getBranchConfiguration(branchId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GdvInsuranceClaimingBranchConfigurationDto>>;
    public getBranchConfiguration(branchId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (branchId === null || branchId === undefined) {
            throw new Error('Required parameter branchId was null or undefined when calling getBranchConfiguration.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<GdvInsuranceClaimingBranchConfigurationDto>(`${this.basePath}/api/InsuranceClaimingConfigurationView/branch/${encodeURIComponent(String(branchId))}/gdv`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGdvGatewayConfigurationByCountryId(countryId: string, observe?: 'body', reportProgress?: boolean): Observable<GdvInsuranceClaimingConfigurationDto>;
    public getGdvGatewayConfigurationByCountryId(countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GdvInsuranceClaimingConfigurationDto>>;
    public getGdvGatewayConfigurationByCountryId(countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GdvInsuranceClaimingConfigurationDto>>;
    public getGdvGatewayConfigurationByCountryId(countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling getGdvGatewayConfigurationByCountryId.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<GdvInsuranceClaimingConfigurationDto>(`${this.basePath}/api/InsuranceClaimingConfigurationView/country/${encodeURIComponent(String(countryId))}/gdv`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/InsuranceClaimingConfigurationView/user/branch/gdv AmsResource:{country}/{business} 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGdvUserBranchAccess(observe?: 'body', reportProgress?: boolean): Observable<GdvInsuranceClaimingBranchConfigurationDto>;
    public getGdvUserBranchAccess(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GdvInsuranceClaimingBranchConfigurationDto>>;
    public getGdvUserBranchAccess(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GdvInsuranceClaimingBranchConfigurationDto>>;
    public getGdvUserBranchAccess(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<GdvInsuranceClaimingBranchConfigurationDto>(`${this.basePath}/api/InsuranceClaimingConfigurationView/user/branch/gdv`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/InsuranceClaimingConfigurationView/user/business/gdv AmsResource:{country}/{business} 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGdvUserBusinessAccess(observe?: 'body', reportProgress?: boolean): Observable<GdvInsuranceClaimingBranchConfigurationDto>;
    public getGdvUserBusinessAccess(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GdvInsuranceClaimingBranchConfigurationDto>>;
    public getGdvUserBusinessAccess(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GdvInsuranceClaimingBranchConfigurationDto>>;
    public getGdvUserBusinessAccess(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<GdvInsuranceClaimingBranchConfigurationDto>(`${this.basePath}/api/InsuranceClaimingConfigurationView/user/business/gdv`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
